import type { MethodologyEntity, MethodologyPayload } from '@protector/entities/methodology/models';
import type { CommandRequest, UUID } from '@protector/utils/types';

export const MethodologyActionTypes = {
  LOAD_METHODOLOGIES_BY_COMPANY: '[Methodology] Load Methodology by Company',
  LOAD_METHODOLOGIES_BY_COMPANY_SUCCESS: '[Methodology] Load Methodology by Company Success',
  LOAD_METHODOLOGIES_BY_COMPANY_FAILURE: '[Methodology] Load Methodology by Company Failure',

  UPDATE_METHODOLOGY: '[Methodology] Update Methodology',
  UPDATE_METHODOLOGY_SUCCESS: '[Methodology] Update Methodology Success',
  UPDATE_METHODOLOGY_FAILURE: '[Methodology] Update Methodology Failure',

  HYDRATE_METHODOLOGY_DETAIL: '[Methodology] Hydrate Methodology Detail'
} as const;

export const LoadMethodologiesByCompany = (company_id: UUID) => {
  return {
    type: MethodologyActionTypes.LOAD_METHODOLOGIES_BY_COMPANY,
    payload: company_id
  };
};

export const LoadMethodologiesByCompanySuccess = (methodologies: MethodologyEntity[]) => {
  return {
    type: MethodologyActionTypes.LOAD_METHODOLOGIES_BY_COMPANY_SUCCESS,
    payload: methodologies
  };
};

export const LoadMethodologiesByCompanyFailure = (error: string) => {
  return {
    type: MethodologyActionTypes.LOAD_METHODOLOGIES_BY_COMPANY_FAILURE,
    payload: error
  };
};

export const UpdateMethodology = (methodology: CommandRequest<MethodologyPayload>) => {
  return {
    type: MethodologyActionTypes.UPDATE_METHODOLOGY,
    payload: methodology
  };
};

export const UpdateMethodologySuccess = (methodology: MethodologyEntity) => {
  return {
    type: MethodologyActionTypes.UPDATE_METHODOLOGY_SUCCESS,
    payload: methodology
  };
};

export const UpdateMethodologyFailure = (error: string) => {
  return {
    type: MethodologyActionTypes.UPDATE_METHODOLOGY_FAILURE,
    payload: error
  };
};

export const HydrateMethodologyDetail = (methodology: MethodologyEntity) => {
  return {
    type: MethodologyActionTypes.HYDRATE_METHODOLOGY_DETAIL,
    payload: methodology
  };
};
